import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu, TrendingUp } from 'lucide-react';

export const Header = ({ activeSection, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'rankings', label: 'Rankings' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  const handleNav = (id) => {
    onNavigate(id);
    setIsOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80">
      <div className="container mx-auto flex h-16 items-center justify-between px-4 lg:px-8">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary">
            <TrendingUp className="h-5 w-5 text-primary-foreground" />
          </div>
          <div className="flex flex-col">
            <span className="font-serif text-lg font-semibold text-foreground leading-tight">
              Top Fund Rankings
            </span>
            <span className="text-xs text-muted-foreground">
              Global Investment Intelligence
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Button
              key={item.id}
              variant="ghost"
              className={`font-sans text-sm font-medium transition-colors ${
                activeSection === item.id
                  ? 'text-accent bg-accent/10'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
              onClick={() => handleNav(item.id)}
            >
              {item.label}
            </Button>
          ))}
        </nav>

        {/* CTA Button - Desktop */}
        <div className="hidden md:block">
          <Button 
            className="btn-premium bg-primary text-primary-foreground hover:bg-primary/90 font-sans text-sm font-medium"
            onClick={() => handleNav('rankings')}
          >
            View Rankings
          </Button>
        </div>

        {/* Mobile Menu */}
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" aria-label="Open menu">
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[280px] bg-card z-[101]">
            <nav className="flex flex-col gap-2 mt-8 relative z-[102]">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`w-full text-left px-4 py-3 rounded-md font-sans text-base transition-colors ${
                    activeSection === item.id
                      ? 'text-accent bg-accent/10 font-medium'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                  onClick={() => handleNav(item.id)}
                >
                  {item.label}
                </button>
              ))}
              <button 
                type="button"
                className="mt-4 w-full px-4 py-3 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-sans font-medium transition-colors"
                onClick={() => handleNav('rankings')}
              >
                View Rankings
              </button>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
